import React from 'react';
import PropTypes from 'prop-types';
import { FaCheck, FaExclamationTriangle } from 'react-icons/fa';

import { AsideCheckItem } from '../../../../styles/ui/Composer';

// Linha do checklist do aside (criação e edição do pedido): ✓ verde quando a
// condição está satisfeita, ⚠ âmbar quando é aviso — nunca erro bloqueante por
// si (quem bloqueia é a ação, desabilitada).
export default function CheckLine({ ok, children }) {
   return (
      <AsideCheckItem $ok={ok}>
         <span className="ic" aria-hidden="true">
            {ok ? <FaCheck size={11} /> : <FaExclamationTriangle size={11} />}
         </span>
         <span>{children}</span>
      </AsideCheckItem>
   );
}

CheckLine.propTypes = {
   ok: PropTypes.bool.isRequired,
   children: PropTypes.node.isRequired,
};
